import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import WidgetDescription from '../WidgetDescription';
import DoughnutChart from '../../Charts/DoughnutChart';
import TableToggle from '../TableToggle';
import { Col, Row } from 'react-bootstrap';
import KeyValueData from '../../Charts/KeyValueData';
import useTableToggle from '../../Hooks/useTableToggle';
import NoData from '../NoData';
import { colors } from '../../../utilities/formats';

export default function RaceEthnicity({ institutionData }) {

    const { table, handleTable } = useTableToggle();
    const title = "Race/Ethnicity";
    const fields = [
        { "field": 'sae_aina_2023', "label": 'American Indian or Alaska Native', 'color': colors.lightblue },
        { "field": 'sae_black_2023', "label": 'Black', 'color': colors.green },
        { "field": 'sae_hispanic_2023', "label": 'Hispanic', 'color': colors.darkblue },
        { "field": 'sae_nhpi_2023', "label": 'Native Hawaiian/ Pacific Islander', 'color': colors.darkred },
        { "field": 'sae_two_or_more_2023', "label": 'Two or more races', 'color': colors.pink },
        { "field": 'sae_asian_2023', "label": 'Asian', 'color': colors.red },
        { "field": 'sae_white_2023', "label": 'White', 'color': colors.orange },
    ]

    let data = [];

    fields.forEach((field) => {
        const value = institutionData.post_meta[field.field].value;
        if (value != 0) {
            data.push({
                label: field.label,
                value: parseFloat(value * 100),
                color: field.color,
            });
        }
    });

    const urm = {
        label: "Underrepresented Minority Enrollment",
        value: institutionData.post_meta.sae_urm_2023.value
    }

    if (!urm.value) {
        return <NoData widgetTitle={title} />;
    }

    // format center number
    let centerNumberString = (urm.value * 100).toFixed(1);
    // if centerNumberString ends with .0, make it an integer
    if (centerNumberString.endsWith('.0')) {
        centerNumberString = centerNumberString.slice(0, -2);
    }

    return (
        <Widget className="race-ethnicity">
            <Row gap={5} gap-lg={0}>
                <Col xs={12} sm={9}>
                    <WidgetTitle>{title}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3}>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <WidgetDescription>
                Percent of degree- or certificate-seeking undergraduate students who institutions reported identifying with the following races and ethnicities.
            </WidgetDescription>

            {!table ? (
                <div className="d-block d-md-flex">
                    <div className="w-50">
                        <DoughnutChart
                            data={data}
                            secondaryData={urm}
                            centerNumber={centerNumberString + "%"}
                            centerText="Underrepresented\nMinority Enrollment"
                            legendDiv="raceLegend"
                            numberFormat={["percent", 0]}
                            colorRamp={data.map((entry) => entry.color)}
                        />
                    </div>
                    <div className='dotLegend w-50 d-flex align-items-center p-3' id='raceLegend'></div>
                </div>
            ) : <KeyValueData data={data} numberFormat="percent" />}

        </Widget>
    );
}